import styled from "styled-components";

export const Container = styled.div`
    // width: 90%;
    // position: relative;
    // max-width: 1420px;
    // margin: auto;
   
    // .textStatus{
    //     margin-top: 10px;
    //     text-align: center;
    // }
    // h1{
    //     font-weight: bold;
    //     color: #4e3628;
    //     font-size: 2em;
    //     text-align: center;
    //     text-transform: uppercase;
    //     letter-spacing: 2px;
    // }
    // .InfoUser{
    //     padding: 2rem 4rem;
    //     width: fit-content;
    //     text-align: center;
    //     background-color: white;
    //     box-shadow: #fbe77724 0px 0px 20px;
    //     margin: auto;
    //     border-radius: 10px;
        
    //     h2{
    //         text-transform: uppercase;

    //         &:not(:last-child){
    //             margin-bottom: 10px;
    //         }
    //     }
        
    // }
    // .imgHr{
    //     position: relative;
    //     margin: 3rem 0px;
    //     img{
    //         position: absolute;
    //         top: 50%;
    //         left: 50%;
    //         transform: translate(-50%, -50%);
    //         width: 50px;
    //     }
    // }
    // hr{
    //     margin: 3rem 0px;
    //     border-color: #d2d0c1;
    // }

    // .premioContainer{
    //     max-width: 1420px;
    //     display: flex;
    //     margin: 2rem auto;
    // }
    
    
`;

